import { MantineTheme } from "@mantine/core";
import { createStyles } from "@mantine/emotion";

export const useStyles = createStyles((_theme: MantineTheme) => ({
  // Sits inside AuthLayout's form column — full width, no card chrome.
  loginContainer: {
    width: "100%",
  },
  loginHeading: {
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "0em",
    textAlign: "left",
    color: "#15292B",
  },
  subHeading: {
    marginTop: "8px",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: "0em",
    textAlign: "left",
    color: "#6b7280",
  },
  inputGroupContainer: {
    width: "100%",
    marginTop: "24px",
    // Targets `[data-variant]`, not `input` — see LoginCss.tsx's inputstyle
    // for why (Mantine's PasswordInput separates the bordered box from the
    // native input; TextInput happens to collapse them into one element, but
    // this selector is robust to either case).
    "& [data-variant]": {
      // Mantine's own focus rule reads `--input-bd-focus` (default: the theme's
      // primary colour), so overriding the variable is what actually recolours
      // the ring — a plain `borderColor` here would lose to it on specificity.
      // Idle border is left untouched (Mantine's default gray-4).
      "--input-bd-focus": "#338F86",
    },
  },
  checkboxContainer: {
    width: "247px",
    height: "22px",
    gap: "6px",
  },
  buttonDiv: {
    paddingTop: "10px",
    marginTop: "20px",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
  signInFooter: {
    width: "209px",
    height: "17px",
    top: "350px",
    position: "absolute",
    marginTop: "30px",
    gap: "10px",

    display: "flex",
    flexDirection: "row",
    marginLeft: "72px",
    justifyContent: "flex-start",
  },
  noAccount: {
    width: "155px",
    height: "25px",
    /*typegraphy*/
    fontFamily: "SF Pro Text",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "16.71px",
    color: "#4F566B",
  },
  signUp: {
    width: "50px",
    height: "17px",
    /*typegraphy*/
    fontFamily: "SF Pro Text",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "16.71px",
    color: "#338F86",
    left: "135px",
    position: "absolute",
    cursor: "pointer",
    paddingLeft: "18px",
  },
  body: {
    fontFamily: "sans-serif",
    backgroundColor: "#fff",
  },

  fhGreen: {
    color: "#338F86",
  },

  fhGrey: {
    color: "#4F566B",
  },

  h1: {
    textAlign: "center",
    fontSize: 24,
    marginBottom: 20,
  },

  h2: {
    fontSize: 18,
    marginBottom: 10,
  },

  input: {
    padding: 10,
    marginBottom: 10,
    backgroundColor: "#338F86",
    color: "white",
    border: "none",
    borderRadius: 10,
    cursor: "pointer",
    width: "100%",
    height: 48,
    marginTop: 10,
    boxShadow: "0 8px 18px rgba(51,143,134,0.25)",
    transition: "background-color 0.25s ease, transform 0.2s ease",
    "&:hover": {
      backgroundColor: "#2b7a72",
      transform: "translateY(-1px)",
    },
  },

  a: {
    textDecoration: "none",
    color: "#4CAF50",
  },

  BackImage: {
    position: "absolute",
    width: 623,
    height: 832,
    left: 657,
    top: 0,
  },

  linkText: {
    fontFamily: "SF Pro Text",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 17,
    display: "flex",
    alignItems: "center",
  },

  smallText: {
    fontFamily: "SF Pro Text",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 17,
    display: "flex",
    alignItems: "center",
  },

  LoginForgotPasswordInput: {
    marginTop: -20,
  },
}));
